import * as React from 'react';
import { Link } from 'react-router-dom';

const FooterComponent: React.StatelessComponent = () => (
  <footer className="Footer">
    <div className="container">
      <div className="gap-50"/>
      <div className="row">
        <div className="col-md-2">
          <h5>
            Compañía
          </h5>
          <ul className="format-list">
            <li>
              <Link to="/nuestro-equipo">
                Quiénes somos
              </Link>
            </li>
            <li>
              <Link to="/contacto">
                Trabaja con nosotros
              </Link>
            </li>
            <li>
              <Link to="/contacto">
                Contacto
              </Link>
            </li>
          </ul>
          <div className="gap-20"/>
        </div>
        <div className="col-md-2">
          <h5>
            Cómo funciona
          </h5>
          <ul className="format-list">
            <li>
              <Link to="/como-invertir">
                Cómo invertir
              </Link>
            </li>
            <li>
              <Link to="/como-financiar-tu-startup">
                Consigue financiación
              </Link>
            </li>
            <li>
              <Link to="/faq">
                FAQs
              </Link>
            </li>
            <li>
              <a href="http://blog.thecrowdangel.com/" target="_blank">
                Blog
              </a>
            </li>
          </ul>
          <div className="gap-20"/>
        </div>
        <div className="col-md-3">
          <h5>Información legal</h5>
          <ul className="format-list">
            <li>
              <Link to="/acreditacion-cnmv">
                Acreditación CNMV
              </Link>
            </li>
            <li>
              <Link to="/acreditacion-accio">
                Acreditación ACCIÓ
              </Link>
            </li>
            <li>
              <Link to="/terminos-y-condiciones">
                Términos y condiciones del inversor
              </Link>
            </li>
            <li>
              <Link to="/informacion-basica">
                Riesgos de inversión en una PFP
              </Link>
            </li>
            <li>
              <Link to="/politica-de-privacidad">
                Privacidad
              </Link>
            </li>
            <li>
              <Link to="/politica-de-cookies">
                Política de Cookies
              </Link>
            </li>
          </ul>
          <div className="gap-20"/>
        </div>
        <div className="col-sm-12 col-md-4 col-md-offset-1">
          <div className="gap-10"/>
          <img
            className="img-responsive"
            alt="The Crowd Angel"
            src="/img/the-crowd-angel-big.png"
          />
          <div className="gap-10"/>
          <img
            alt="Generalitat"
            src="/img/generalitat.png"
            className="img-responsive"
          />
          <div className="gap-10"/>
          <h5 className="chain-title">Sitio seguro</h5>
          <p className="chain-text">The Crowd Angel PFP, S.L. es una plataforma de financiación participativa 
          autorizada por la CNMV conforme a la Ley 5/2015 de Fomento de la Financiación Empresarial.</p>
        </div>
      </div>
      <hr/>
      <div className="row">
        <div className="col-sm-5 col-sm-offset-7 text-right">
          <div className="gap-20"/>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <p>
            The Crowd Angel ® 2020 es una plataforma de financiación participativa acreditada por la CNMV.
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/footer/Footer.component.tsx